import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LetDirective, PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';

import { ClickOutsideDirective, StopPropagationDirective } from '@ninety/ui/core';

import { MazSelectors } from '../../../maz/_state/maz.selectors';
import { MazChatComponent } from '../../../maz/components/maz-chat/maz-chat.component';
import { GuideActions } from '../../_state/guide.actions';
import { GuideSelectors } from '../../_state/guide.selectors';
import { PhaseDetailsComponent } from '../phase-details/phase-details.component';
import { PhaseListComponent } from '../phase-list/phase-list.component';

import { mazChatAnimation } from './getting-started-guide.animation';

@Component({
  selector: 'ninety-getting-started-guide',
  templateUrl: './getting-started-guide.component.html',
  styleUrls: ['./getting-started-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [mazChatAnimation],
  standalone: true,
  imports: [
    LetDirective,
    StopPropagationDirective,
    ClickOutsideDirective,
    PhaseListComponent,
    PhaseDetailsComponent,
    MazChatComponent,
    PushPipe,
  ],
})
export class GettingStartedGuideComponent implements OnInit {
  private readonly store = inject(Store);

  protected readonly selectedPhase$ = this.store.select(GuideSelectors.selectSelectedPhase);
  protected readonly mazChatEnabled$ = this.store.select(MazSelectors.selectMazChatEnabled);
  protected readonly isMazChatExpanded$ = this.store.select(MazSelectors.selectIsMazChatExpanded);

  ngOnInit() {
    /** use this if the definitions of done become more complex and hard to put everywhere */
    this.store.dispatch(GuideActions.checkCompletionStatus());
  }

  close() {
    this.store.dispatch(GuideActions.closeGuide());
  }
}
